import React, { useRef, useEffect } from 'react';
import useWindowRezise from '../hooks/useWindowRezise';

const CategorySlider = ({ values }) => {
    const container = useRef(null);
    const prev = useRef(null);
    const next = useRef(null);
    const { width } = useWindowRezise();
    let widthComputed = 0;
    let totalWidth = 0;
    useEffect(() => {
        if (container.current && container.current.children.length > 4) {
            widthComputed =
                width >= 768
                    ? container.current.children[1].offsetWidth * 3
                    : container.current.children[1].offsetWidth * 2;
            totalWidth =
                (container.current.children.length - 2) *
                container.current.children[1].offsetWidth -
                container.current.offsetWidth;
            if (totalWidth <= 0)
                next.current.classList.remove('category-slider__list-nav--show');
        }
    }, [container.current]);
    const scrollToNextPage = () => {
        container.current.scrollBy({
            top: 0,
            left: widthComputed,
            behavior: 'smooth',
        });
    };
    const scrollToPrevPage = () => {
        container.current.scrollBy({
            top: 0,
            left: -widthComputed,
            behavior: 'smooth',
        });
    };
    const setButtons = (e) => {
        if (
            e.target.scrollLeft > 50 &&
            !prev.current.classList.contains('category-slider__list-nav--show')
        )
            prev.current.classList.add('category-slider__list-nav--show');
        else if (
            e.target.scrollLeft <= 50 &&
            prev.current.classList.contains('category-slider__list-nav--show')
        )
            prev.current.classList.remove('category-slider__list-nav--show');
        if (
            e.target.scrollLeft <= totalWidth - 50 &&
            !next.current.classList.contains('category-slider__list-nav--show')
        )
            next.current.classList.add('category-slider__list-nav--show');
        else if (
            e.target.scrollLeft > totalWidth - 50 &&
            next.current.classList.contains('category-slider__list-nav--show')
        )
            next.current.classList.remove('category-slider__list-nav--show');
    };

    return (
        <div
            onScroll={(e) => setButtons(e)}
            ref={container}
            className="category-slider__list"
        >
            <button
                onClick={() => scrollToPrevPage()}
                aria-label="Go to previous slide"
                className="category-slider__list-nav category-slider__list-nav--prev"
                type="button"
                ref={prev}
            ></button>
            {values &&
                values.length > 0 &&
                values.map((value, index) => (
                    <div className="category-slider__list-item" key={`figure${index}`}>
                        <a className="category-slider__list-item-link" href={value.url}>
                            <img
                                alt={value.name}
                                className="category-slider__list-item-image"
                                src={value.image}
                            />
                            <p className="category-slider__list-item-text">{value.name}</p>
                        </a>
                    </div>
                ))}
            <button
                onClick={() => scrollToNextPage()}
                aria-label="Go to next slide"
                className="category-slider__list-nav category-slider__list-nav--show category-slider__list-nav--next"
                type="button"
                ref={next}
            ></button>
        </div>
    );
};
export default CategorySlider;
